import ReportsContainer from './reports-container';

export default ReportsContainer;
